import { render, staticRenderFns } from "./_base-menu-icon.vue?vue&type=template&id=ce21b9c4&scoped=true"
import script from "./_base-menu-icon.vue?vue&type=script&lang=js"
export * from "./_base-menu-icon.vue?vue&type=script&lang=js"
import style0 from "./_base-menu-icon.vue?vue&type=style&index=0&id=ce21b9c4&prod&style=scss&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce21b9c4",
  null
  
)

export default component.exports